module.exports = __webpack_public_path__ + "img/Bootfahren.1b480537.jpg";